import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { LoginComponent } from './core/login/login.component';
import { HomeComponent } from './modules/home-component/home.component';
import { ForgotPasswordConfirmationComponent } from './core/forgot-password/forgot-password-confirmation/forgot-password-confirmation.component';
import { ForgotPasswordChangeComponent } from './core/forgot-password/forgot-password-change/forgot-password-change.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: HomeComponent,
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./modules/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
      },

      // remove when Admin module not needed
      {
        path: 'admin',
        loadChildren: () =>
          import('./modules/admin/admin.module').then(
            (m) => m.AdminModule
          ),
      },
      {
        path: 'maindata',
        loadChildren: () =>
          import('./modules/maindata/maindata.module').then(
            (m) => m.MainDataModule
          ),
      },
      {
        path: 'wikis',
        loadChildren: () =>
          import('./modules/documentation/documentation.module').then(
            (m) => m.DocumentationModule
          ),
      },
      
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordChangeComponent,
  },
  {
    path: 'forgot-password/confirmation',
    component: ForgotPasswordConfirmationComponent,
  },
  {
    path: 'forgot-password/change',
    component: ForgotPasswordChangeComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
